const numberLocales: { [lng: string]: Intl.LocalesArgument } = {
    cs: 'cs-cz',
    en: 'en-us',
};

let locale: Intl.LocalesArgument = numberLocales.en;

export function setNumberLocale(lng: string) {
    locale = numberLocales[lng] || numberLocales.en;
}

export function decimalNumber(v: number, minDigits: number = 2, maxDigits?: number): string {
    return v.toLocaleString(locale, {minimumFractionDigits: minDigits, maximumFractionDigits: maxDigits});
}
